
            // Load /config/app-config.json into window.__APP_CONFIG__ BEFORE the
            // app bundle evaluates, so app-config-runtime.ts reads it synchronously
            // on init and the first paint has the deployed config (no flicker). The
            // public *.eatmydata.ai site ships no /config/ and uses the bundled
            // config, so it skips the guaranteed-404 fetch. Either way the app
            // loads exactly once; a missing/404/invalid config falls back to bundled.
            //
            // The entry is loaded via a static-string dynamic import() so Vite
            // rewrites it to the hashed bundle at build time. A `script.src` string
            // is opaque to Vite's HTML scan and would 404 in the deployed build.
            if (!location.hostname.endsWith('eatmydata.ai')) {
                try {
                    const rep = await fetch('/config/app-config.json', { redirect: 'follow' });
                    if (rep.ok) {
                        try {
                            window.__APP_CONFIG__ = JSON.parse(await rep.text());
                        } catch (e) {
                            console.warn(
                                '[app-config] invalid /config/app-config.json; using bundled config',
                                e,
                            );
                        }
                    }
                } catch (e) {
                    console.warn(
                        '[app-config] could not fetch /config/app-config.json; using bundled config',
                        e,
                    );
                }
            }
            await import('/src/index.tsx').catch((e) => console.error('Error loading app', e));
        